<template>
  <div class="spinner-container">
    <div class="lds-spinner">
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
    </div>
  </div>
  <div class="main-wrapper">
    <transition-group name="fade" appear>
      <template v-if="images.length > 0">
        <div
          v-for="(item, index) in images"
          :key="item?.id"
          class="carousel-item"
          v-show="index === activeIndex"
        >
          <ImageContainer
            :src="item.image?.large"
            :thumb="item.image?.thumbnail"
            :alt="item.title"
            :ignoreError="true"
          />
        </div>
      </template>
    </transition-group>
  </div>
</template>

<script>
import { ref } from "vue";
import ImageContainer from "@/components/ImageContainer";
export default {
  name: "FadeCarousel",
  components: {
    ImageContainer,
  },
  props: {
    images: Array,
  },
  setup(props) {
    const activeIndex = ref(0);

    const incrementActiveIndex = (to) => {
      activeIndex.value =
        activeIndex.value + to < 0
          ? (activeIndex.value = props.images.length - 1)
          : activeIndex.value + to > props.images.length - 1
          ? 0
          : activeIndex.value + to;
    };

    return { activeIndex, incrementActiveIndex };
  },
};
</script>

<style lang="scss" scoped>

.main-wrapper {
  width: 100%;
  height: 100%;
  position: relative;
  pointer-events: none;

  .carousel-item {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      background-color: transparent;
    }
  }
}
</style>
